import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import {
	DELETE_TASKS,
	GET_ALL_TASKS_LIST,
	GET_ALL_TASKS_LISTV2,
	MOVE_TASK,
} from "../../../../graphql/task";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import { useTranslation } from "react-i18next";
import Mnemonic from "../../../../Mnemonics.json";
import { GET_USER_TABLE_PREFERENCES } from "../../../../graphql/userTablePreferences";
import { Parse } from "../../../../JSON.editor";
import componentDisplay from "../../../../componentDisplay";
import UTC2Local, { formatDateTimeToString } from "../../../../UTC2Local";
import { decodeUnicodeString } from "../../../../utils/decodeUnicodeString";
import { removeNullProps } from "../../../../utils/removeNullProps";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

import {
	GET_USER_TABLE_FILTERS,
	REMOVE_USER_TABLE_FILTERS,
	SAVE_USER_TABLE_FILTERS,
} from "../../../../graphql/userTableFilters";

import { useTaskFilters } from "./UseTaskFilters";
import {
	MaterialReactTable,
	useMaterialReactTable,
} from "material-react-table";
import useColumnsConfig from "./_tableColumns";
import tableStyles from "./tableStyles";
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import { CircularProgress, Grid, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import DataTable from "../../../../components/Tables/DataTable";
import urls from "../../../../urls";
import {
	getOptionPriorityIcon,
	SubtaskIcon,
} from "../../../../components/Icon";
import colors from "../../../../assets/theme/light/colors";
import { enqueueSnackbar } from "notistack";
import SavedFilters from "./_savedFilters";
import ConfirmationModal from "../../../../components/Modal/ConfirmationModal";
import CustomButton from "../../../../components/CustomButton";
import { TaskBoard } from "./BoardV2";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";

const {
	tenant_project_tasks_form,
	my_project_tasks_form,
	tenant_project_direct_tasks_form,
	my_project_direct_tasks_form,
	project_backlog_tasks,
} = urls;
function TaskList(props) {
	const {
		parentGuid,
		parentName,
		handleCloseModal,
		fromSubtask,
		fromTenant,
		fromProject,
		fromTicket,
		fromProjectTasks,
		fromBacklog,
		outSide,
		fromEmployeeAvailability,
	} = props;

	const {
		defaultFilters,
		filterState,
		filtersObject,
		setDefaultFilters,
		setFilterState,
		statusData,
		teamsData,
		employeesData,
		areaData,
		projectsData,
		parentTaskData,
	} = useTaskFilters({
		fromProject,
		fromTicket,
		fromTenant,
	});

	const {
		storeUserGuid,
		storeUserTenant,
		storeUserTeams,
		isEmployee,
		userRoles,
	} = useAuth();
	const { tID, tName, tkID, tkName, pID } = useParams();

	const {
		data: getFilters,
		loading: filterLoading,
		refetch: refetchFilters,
	} = useQueryAuth(GET_USER_TABLE_FILTERS, "GetUserTableFilters", {
		variables: {
			model: {
				userID: storeUserGuid,
				tableName: Mnemonic.Tables.TasksBacklog,
				projectID: pID ? pID : null,
			},
		},
	});

	const { cfunction: moveTaskData } = useMutationAuth(MOVE_TASK, "MoveTask");
	const { cfunction: saveUserTableFiltersData } = useMutationAuth(
		SAVE_USER_TABLE_FILTERS,
		"SaveUserTableFilters"
	);

	const { cfunction: removeUserTableFiltersData } = useMutationAuth(
		REMOVE_USER_TABLE_FILTERS,
		"RemoveUserTableFilters"
	);

	const { mfunction: deleteRecords, loading: deleteLoading } = useMutationAuth(
		DELETE_TASKS,
		"DeleteListOfTasks"
	);

	const handleSaveUserTableFilters = (
		filter,
		name = null,
		newFilter = true
	) => {
		saveUserTableFiltersData(
			{
				variables: {
					model: {
						filterID: newFilter ? null : selectedFilterGuid,
						userID: storeUserGuid,
						projectID: pID,
						filterName: name,
						tableName: Mnemonic.Tables.TasksBacklog,
						tableFilters: filter,
					},
				},
			},
			(response) => {
				if (
					response["SaveUserTableFilters"].errorCode !== null &&
					response["SaveUserTableFilters"].errorCode !== ""
				) {
					enqueueSnackbar(
						t(response["SaveUserTableFilters"].errorMessage),
						{
							variant: "error",
							autoHideDuration: 5000,
						}
					);
				} else {
					enqueueSnackbar(t("task.list.savedSuccessfully"), {
						variant: "success",
					});
					const guid =
						response["SaveUserTableFilters"]?.userTableFilters
							?.userTableFiltersGuid;
					// setSelectedFilterGuid(guid);
					refetchFilters();
					setOpenSavedFilters(true);
					if (newFilter === true) {
						if (!pID) {
							localStorage.setItem(
								"task_filter",
								JSON.stringify(filter)
							);
							localStorage.setItem(
								"task_filter_guid",
								JSON.stringify(guid)
							);
						} else {
							localStorage.setItem(
								"project_task_filter",
								JSON.stringify(filter)
							);
							localStorage.setItem(
								"project_task_filter_guid",
								JSON.stringify(guid)
							);
							localStorage.setItem(
								"project_filter_guid",
								JSON.stringify(pID)
							);
						}
					}
					return true;
				}
			},
			(error) => {}
		);
	};
	const [showAsBoard, setShowAsBoard] = useState(null);

	const { isAdmin, manageTimeEntry } = userRoles;
	const [columnOrder, setColumnOrder] = useState([]);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [showParents, setShowParents] = useState(pID ? true : false);
	const [isError, setIsError] = useState(false);
	const [columnFilters, setColumnFilters] = useState([]);
	const [showQuickFilters, setShowQuickFilters] = useState(() => {
		const savedState = localStorage.getItem("showQuickFilters");
		return savedState === "true";
	});
	const [openModal, setOpenModal] = useState(false);

	const [selectedFilterGuid, setSelectedFilterGuid] = useState(null);
	const [rowSelection, setRowSelection] = useState({});
	const [columns, setColumns] = useState([]);
	const [page, setPage] = useState(0);
	const [pageSize, setPageSize] = useState(rowsPerPage);
	const [data, setData] = useState([]);
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("Title");
	const [search, setSearch] = useState("");
	const [sorting, setSorting] = useState([]);
	const [type, setType] = useState(fromSubtask ? "subtask" : "task");
	const [rowCount, setRowCount] = useState(0);
	const [movedRow, setMovedRow] = useState({});
	const [targetRow, setTargetRow] = useState({});
	const [pendingMove, setPendingMove] = useState(null);
	const [fetchedData, setFetchedData] = useState([]);
	const [openMovedRowDialog, setOpenMovedRowDialog] = useState(false);
	const [loadingRowIds, setLoadingRowIds] = useState(new Set());
	const [selected, setSelected] = useState([]);
	const [openSavedFilters, setOpenSavedFilters] = useState(false);
	const [doing, setDoing] = useState(false);
	const count = useRef(0);
	const [assignedToMe, setAssignedToMe] = useState(pID ? false : true);
	const [filters, setFilters] = useState(null);
	const [openDeleteFilterModal, setOpenDeleteFilterModal] = useState(false);
	const [filterGuidToBeRemoved, setFilterGuidToBeRemoved] = useState(null);
	const [modalData, setModalData] = useState(null);
	const addNewSubtask = useRef(false);

	//todo fix me
	const { t } = useTranslation();
	const isMember = false;

	const [chipFilters, setChipFilters] = useState({
		showParents: pID ? true : false,
		assignedToMe:
			isAdmin || pID ? false : fromEmployeeAvailability ? false : true,
		assignedToMyTeam:
			isAdmin || pID ? false : fromEmployeeAvailability ? false : true,
		onlySubtasks: true,
		onlyTasks: true,
		myProjectTasks:
			isAdmin && !fromProject
				? false
				: isAdmin && fromProject && isMember
				? true
				: isAdmin && fromProject && !isMember
				? false
				: pID
				? true
				: false,
		doing: false,
	});

	const { loading: getColumnsLoading } = useQueryAuth(
		GET_USER_TABLE_PREFERENCES,
		"GetUserTablePreferences",
		{
			variables: {
				model: {
					userID: storeUserGuid,
					table: Mnemonic.Tables.TasksBacklog,
				},
			},
		},
		{
			onCompleted: (data) => {
				let cols = data?.GetUserTablePreferences?.columns || null;
				if (cols) {
					cols = decodeUnicodeString(cols);

					// Parse the JSON string to a JSON object
					const parsed = JSON.parse(cols, (key, value) =>
						Parse(
							key,
							value,
							UTC2Local,
							componentDisplay,
							null,
							null,
							null,
							formatDateTimeToString
						)
					);

					if (parsed.columns) {
						let cols = parsed.columns;

						cols.map((c) => {
							c = removeNullProps(c);
							return c;
						});
						setColumns(cols);
					}
					if (parsed.columns)
						setColumnOrder(parsed.columns.map((x) => x.id));
					if (parsed.defaultSort) setOrderBy(parsed.defaultSort);
					if (parsed.defaultSortDirection)
						setOrder(parsed.defaultSortDirection);
				}
			},
		}
	);
	const handleSearch = async (value) => {
		setSearch(value);
		if (value === "" || value == null) {
			await handleRefetchTree();
		} else {
			await fetchTasks(
				{
					variables: {
						model: {
							keys: !chipFilters?.showParents
								? {
										page: page + 1 || 1,
										pageSize: pageSize || 20,
								  }
								: null,
							showParentsHierarchy: chipFilters?.showParents,
							enableFilters: true,
							onlyTasks: chipFilters?.onlyTasks,
							onlySubtasks: chipFilters?.onlySubtasks,
							highPriority: chipFilters?.doing,
							myProjectsTasks: chipFilters?.myProjectTasks,
							myTasks: chipFilters?.assignedToMe,
							myTeamsTasks: chipFilters?.assignedToMyTeam,
							projectID: fromTicket
								? pID
								: fromProjectTasks
								? pID
								: null,
							ticketID: fromTicket ? tkID : null,
							onGoingTasks: false,
							filters: defaultFilters,
							userID: storeUserGuid,
							tenantID: storeUserTenant,
							keyWord: value,
							orderDirection:
								sorting?.[0] != null
									? sorting[0].desc
										? "desc"
										: "asc"
									: order,
							orderColumn:
								sorting?.[0] != null ? sorting[0].id : orderBy,
							offset: 3,
						},
					},
				},
				(response) => {
					const data = response?.GetFilteredTasks?.tasksTreeResponse;
					setRowCount(data?.totalNumberOfRecords || 0);
					setData((prev) => {
						prev = {
							GetFilteredTasksV2: {
								tasksTreeResponse: data,
							},
						};
						return {
							...prev,
						};
					});
				}
			);
		}
	};
	const handleRefetchTree = async () => {
		const res = await refetchTasks({
			variables: {
				model: {
					keys: !chipFilters?.showParents
						? {
								page: page + 1 || 1,
								pageSize: pageSize || 20,
						  }
						: null,
					showParentsHierarchy: chipFilters?.showParents,
					enableFilters: true,
					onlyTasks: chipFilters?.onlyTasks,
					onlySubtasks: chipFilters?.onlySubtasks,
					highPriority: chipFilters?.doing,
					myProjectsTasks: chipFilters?.myProjectTasks,
					myTasks: chipFilters?.assignedToMe,
					myTeamsTasks: chipFilters?.assignedToMyTeam,
					projectID: fromTicket ? pID : fromProjectTasks ? pID : null,
					ticketID: fromTicket ? tkID : null,
					onGoingTasks: false,
					filters: defaultFilters,
					userID: storeUserGuid,
					tenantID: storeUserTenant,
					keyWord: undefined,
					orderDirection:
						sorting?.[0] != null
							? sorting[0].desc
								? "desc"
								: "asc"
							: order,
					orderColumn: sorting?.[0] != null ? sorting[0].id : orderBy,
					offset: 3,
				},
			},
		});
		if (res?.data?.GetFilteredTasksV2?.tasksTreeResponse) {
			setData(res.data);
			setRowCount(
				res.data.GetFilteredTasksV2.tasksTreeResponse
					.totalNumberOfRecords || 0
			);
		}
	};
	const { refetch: refetchTasks, loading } = useQueryAuth(
		GET_ALL_TASKS_LISTV2,
		"GetFilteredTasksV2",
		{
			variables: {
				model: {
					keys: !chipFilters?.showParents
						? {
								page: page + 1 || 1,
								pageSize: pageSize || 20,
						  }
						: null,
					showParentsHierarchy: chipFilters?.showParents,
					enableFilters: true,
					onlyTasks: chipFilters?.onlyTasks,
					onlySubtasks: chipFilters?.onlySubtasks,
					highPriority: chipFilters?.doing,
					myProjectsTasks: chipFilters?.myProjectTasks,
					myTasks: chipFilters?.assignedToMe,
					myTeamsTasks: chipFilters?.assignedToMyTeam,
					projectID: fromTicket ? pID : fromProjectTasks ? pID : null,
					ticketID: fromTicket ? tkID : null,
					onGoingTasks: false,
					filters: defaultFilters,
					userID: storeUserGuid,
					tenantID: storeUserTenant,
					keyWord: undefined,
					orderDirection:
						sorting?.[0] != null
							? sorting[0].desc
								? "desc"
								: "asc"
							: order,
					orderColumn: sorting?.[0] != null ? sorting[0].id : orderBy,
					offset: 3,
				},
			},
		},
		{
			onCompleted: (data) => {
				setRowCount(
					data?.GetFilteredTasksV2?.tasksTreeResponse
						?.totalNumberOfRecords || 0
				);
				setData(data);
			},
		},
		false,
		true
	);
	const { mfunction: fetchNewTasks } = useLazyQueryAuth(
		GET_ALL_TASKS_LISTV2,
		"GetFilteredTasksV2"
	);

	const { mfunction: fetchTasks, loading: loadingTasks } = useLazyQueryAuth(
		GET_ALL_TASKS_LIST,
		"GetFilteredTasks"
	);

	const getTotalFilters = () => {
		return {
			quickFilters: chipFilters,
			defaultFilters: defaultFilters,
		};
	};

	const columnsConfig = useColumnsConfig(
		columns,
		t,
		"",
		handleRefetchTree,
		chipFilters,
		defaultFilters,
		sorting,
		search,
		data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews || [],
		(newData) => {
			console.log("Updated Data:", newData);
		},
		getTotalFilters,
		statusData?.GetTaskStatuses?.tasksStatus || []
	);
	useEffect(() => {
		if (getFilters?.GetUserTableFilters?.userTableFiltersList?.length > 0) {
			const activeFilterGuid =
				localStorage.getItem("task_filter_guid") ??
				localStorage.getItem("project_task_filter_guid");
			const latestFilter =
				getFilters.GetUserTableFilters.userTableFiltersList.find(
					(filter) => filter.userTableFiltersGuid === activeFilterGuid
				);

			if (latestFilter) {
				handleApplyFilter(
					latestFilter.userTableFiltersGuid,
					latestFilter.filter
				);
			}
		}
	}, [getFilters]);
	const handleSubmit = async (movedRow, targetRow, actions) => {
		await moveTaskData(
			{
				variables: {
					model: {
						taskGuid: movedRow?.id?.split(".")?.[0],
						parentGuid: targetRow?.id?.split(".")?.[0],
						ticketGuid: targetRow?.ticketGuid,
						projectGuid: targetRow?.projectGuid,
						tenantGuid: storeUserTenant,
					},
				},
			},
			(response) => {
				if (
					response["MoveTask"].errorCode !== null &&
					response["MoveTask"].errorCode !== ""
				) {
					enqueueSnackbar(t(response["MoveTask"].errorMessage), {
						variant: "error",
						autoHideDuration: 5000,
					});
				} else {
					enqueueSnackbar(t("taskForm.movedSuccessfully"), {
						variant: "success",
					});
					handleRefetchTree();
					setPage(0);
					sessionStorage.removeItem("unsavedChanges");
				}
			}
		);
	};
	const handleMovedRowConfirm = () => {
		handleSubmit(movedRow, targetRow);
		setFetchedData([]);
		handleMovedRowClose();
	};
	const customModalMovedRowButtons = () => (
		<>
			<CustomButton
				onClick={handleMovedRowConfirm}
				label={t("dialog.yes")}
			/>
			<div>
				<CustomButton
					onClick={handleMovedRowClose}
					label={t("dialog.cancel")}
				/>
			</div>
		</>
	);
	const handleMovedRowClose = () => {
		setOpenMovedRowDialog(false);
		setPendingMove(null);
	};

	const table = useMaterialReactTable({
		columns: columnsConfig,
		data: loading
			? []
			: data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews || [],
		enableExpandAll: true,
		enableExpanding: showParents ? true : false,
		columnResizeMode: "onChange",
		pageCount: Math.ceil(rowCount / pageSize),
		enableStickyHeader: true,
		enableColumnResizing: true,
		enableDensityToggle: false,
		enableSubRowSelection: false,
		enableFullScreenToggle: false,
		enableFilters: false,
		enableHiding: false,
		enableGlobalFilter: false,
		enableColumnActions: false,
		enableRowSelection: true,
		enableBatchRowSelection: false,
		enablePagination: !showParents,
		enableTopToolbar: false,
		enableSorting: true,
		getIsSomeRowsExpanded: true,
		onColumnOrderChange: setColumnOrder,
		initialState: {
			density: "compact",
			columnPinning: {
				left: [
					"mrt-row-expand",
					"mrt-row-drag",
					"mrt-row-select",
					"ID",
					"Title",
				],
			},
		},
		manualFiltering: true,
		manualPagination: true,
		paginateExpandedRows: true,
		manualSorting: true,
		muiToolbarAlertBannerProps: isError
			? {
					color: "error",
					children: "Error loading data",
			  }
			: undefined,
		onColumnFiltersChange: setColumnFilters,
		onSortingChange: setSorting,
		rowCount: rowCount ?? 0,
		onPaginationChange: (updater) => {
			const next =
				typeof updater === "function"
					? updater({ pageIndex: page, pageSize })
					: updater;
			setPage(next.pageIndex);
			setPageSize(next.pageSize);
		},
		state: {
			columnFilters,
			columnOrder,
			isLoading: loading || loadingTasks,
			showAlertBanner: isError,
			pagination: {
				pageIndex: page,
				pageSize: pageSize,
			},
			sorting,
			rowSelection,
		},
		createDisplayMode: "row",
		editDisplayMode: "table",
		enableEditing: columnsConfig.some((column) => column?.enableEditing),
		displayColumnDefOptions: {
			"mrt-row-drag": {
				enableResizing: false,
				size: 20,
				header: () => null,
			},
			"mrt-row-expand": {
				enableResizing: true,
				size: showParents ? 70 : 50,
				Cell: ({ row, table }) => {
					const id = row.id;

					const isLoading = loadingRowIds.has(id);
					const hasSubs = row.original.task.hasChildren;
					if (!hasSubs) {
						return (
							<IconButton size="small" disabled>
								<KeyboardArrowRight color="disabled" />
							</IconButton>
						);
					}
					if (isLoading) {
						return <CircularProgress size={20} />;
					}
					return (
						<IconButton
							size="small"
							onClick={async () => {
								const nextExpanded = !row.getIsExpanded();
								setLoadingRowIds((prev) => new Set(prev).add(id));
								await getExpandedRowsData({ [id]: nextExpanded });
								setLoadingRowIds((prev) => {
									const copy = new Set(prev);
									copy.delete(id);
									return copy;
								});
								table.setExpanded((old) => ({
									...old,
									[id]: nextExpanded,
								}));
							}}
						>
							{row.getIsExpanded() ? (
								<KeyboardArrowDown />
							) : (
								<KeyboardArrowRight />
							)}
						</IconButton>
					);
				},
			},
			"mrt-row-select": {
				size: 20,
				header: ({ column }) => null,
			},
		},
		getRowId: (originalRow) => originalRow?.task?.guid,
		onRowSelectionChange: setRowSelection,
		getSubRows: (row) => {
			return row?.subtasks;
		},
		enableRowOrdering: pID ? true : false,
		muiRowDragHandleProps: ({ table }) => ({
			onDragEnd: () => {
				const { draggingRow, hoveredRow } = table.getState();
				if (hoveredRow && draggingRow) {
					const {
						id: draggingId,
						original: {
							task: {
								parentTaskGuid: draggingParentTaskGuid,
								ticketGuid: draggingTicketGuid,
								projectGuid: draggingProjectGuid,
							},
						},
					} = draggingRow;

					const {
						id: hoveredId,
						original: {
							task: {
								parentTaskGuid: hoveredParentTaskGuid,
								ticketGuid: hoveredTicketGuid,
								projectGuid: hoveredProjectGuid,
								title,
							},
						},
					} = hoveredRow;

					const movedRow = {
						id: draggingId,
						parentGuid: draggingParentTaskGuid,
						ticketGuid: draggingTicketGuid,
						projectGuid: draggingProjectGuid,
					};
					const targetRow = {
						id: hoveredId,
						parentGuid: hoveredParentTaskGuid,
						ticketGuid: hoveredTicketGuid,
						projectGuid: hoveredProjectGuid,
						title: title,
					};

					setMovedRow(movedRow);
					setTargetRow(targetRow);
					setPendingMove({
						draggingRowIndex: draggingRow.index,
						hoveredRowIndex: hoveredRow.index,
					});

					setOpenMovedRowDialog(true); // Open the confirmation dialog
				}
			},
		}),
		muiTableHeadCellProps: {
			sx: {
				...tableStyles.header,
				"& .MuiDivider-root": {
					borderWidth: "0.00001px",
					height: "48px",
					borderColor: "rgba(0, 0, 0, 0.06) !important",
					marginBottom: "7px",
				},
			},
		},
		muiTableFooterCellProps: {
			sx: tableStyles.footer,
		},
		muiTableBodyProps: {
			sx: tableStyles.body,
		},
		muiTableContainerProps: {
			sx: {
				maxHeight: fromTicket
					? "calc(100vh - 355px)"
					: !fromProjectTasks
					? showQuickFilters === true
						? "calc(100vh - 275px)"
						: "calc(100vh - 213px)"
					: showQuickFilters === true
					? "calc(100vh - 352px)"
					: "calc(100vh - 293px)",
			},
		},
		muiCircularProgressProps: {
			color: "primary",
			thickness: 4,
			size: 35,
		},
		muiSkeletonProps: {
			animation: "pulse",
			height: 28,
		},
		muiTableBodyCellProps: ({ column }) => {
			const cellAligned = column?.columnDef?.align;
			const baseStyles =
				cellAligned === "center"
					? { display: "flex", justifyContent: "center" }
					: {};

			// Check if the column has enableEditing set to true
			const isEditableColumn = column.columnDef.enableEditing;

			return {
				sx: {
					...baseStyles,
					"&:hover": isEditableColumn
						? {
								border: "1px solid #dcdcdc",
						  }
						: {},
				},
			};
		},
	});
	const expanded = table.getState().expanded;
	const updateNodeInTree = useCallback((nodes, id, newData) => {
		if (!Array.isArray(nodes) || nodes.length === 0) {
			return nodes; // nothing to do
		}

		return nodes.map((node) => {
			// 1) if this is the node we want to update, merge in newData and stop
			if (node.task.guid === id) {
				return {
					...node,
					...newData,
				};
			}

			// 2) otherwise, recurse into its real subtasks
			const originalSubs = Array.isArray(node.subtasks) ? node.subtasks : [];
			const updatedSubs = updateNodeInTree(originalSubs, id, newData);

			// 3) if children changed, return a new object; else return the same node
			if (updatedSubs !== originalSubs) {
				return {
					...node,
					subtasks: updatedSubs,
				};
			}

			return node;
		});
	}, []);

	const findTaskByGuid = useCallback((guid, oldViews) => {
		if (!Array.isArray(oldViews) || oldViews.length === 0) {
			return null;
		}

		for (const node of oldViews) {
			if (node.task.guid === guid) {
				return node;
			}
			const foundInSubs = findTaskByGuid(guid, node.subtasks);
			if (foundInSubs) {
				return foundInSubs;
			}
		}
		return null; // not found
	}, []);

	const handleNodeChange = useCallback(
		(id, newData) => {
			setData((prev) => {
				const oldViews =
					prev?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews || [];
				const task = findTaskByGuid(id, oldViews);
				const updatedViews = updateNodeInTree(oldViews, id, {
					subtasks: newData || [],
					task: task?.task || {},
				});

				return {
					...prev,
					GetFilteredTasksV2: {
						...prev.GetFilteredTasksV2,
						tasksTreeResponse: {
							...prev.GetFilteredTasksV2.tasksTreeResponse,
							thisTaskViews: updatedViews,
						},
					},
				};
			});
		},
		[updateNodeInTree, findTaskByGuid]
	);
	// helper: collect every descendant GUID under a given taskView node
	const collectIds = useCallback((res, expandedMap) => {
		const task = res.task;
		return [
			// if this task is expanded, include it
			...(expandedMap[task.guid] ? [task.guid] : []),
			// then recurse into any subtasks, passing expandedMap along
			...(res.subtasks
				? res.subtasks.flatMap((sub) => collectIds(sub, expandedMap))
				: []),
		];
	}, []);

	const getExpandedRowsData = useCallback(
		async (expandedMap) => {
			// 1) grab your current top-level views
			const rootViews =
				data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews ?? [];

			// 2) for every row the user has expanded, collect all descendant GUIDs
			const allIdsToFetch = rootViews.flatMap((tv) =>
				collectIds(tv, expandedMap)
			);

			// // // 3) remove anything we've already fetched
			const idsToFetch = allIdsToFetch.filter(
				(guid) => !fetchedData.some((f) => f === guid)
			);
			if (idsToFetch.length === 0) {
				return;
			}

			// // 4) fetch each missing node (serially to avoid throttling)
			const newlyFetched = [];
			for (const id of idsToFetch) {
				await fetchNewTasks(
					{
						variables: {
							model: {
								keys: !chipFilters?.showParents
									? {
											page: page + 1 || 1,
											pageSize: pageSize || 20,
									  }
									: null,
								showParentsHierarchy: chipFilters?.showParents,
								enableFilters: false,

								onlyTasks: chipFilters?.onlyTasks,
								onlySubtasks: chipFilters?.onlySubtasks,
								highPriority: chipFilters?.doing,
								myProjectsTasks: chipFilters?.myProjectTasks,
								myTasks: chipFilters?.assignedToMe,
								myTeamsTasks: chipFilters?.assignedToMyTeam,
								projectID: fromTicket
									? pID
									: fromProjectTasks
									? pID
									: null,
								ticketID: fromTicket ? tkID : null,
								onGoingTasks: false,
								userID: storeUserGuid,
								tenantID: storeUserTenant,
								parentID: id,
								offset: 3,
							},
						},
					},
					(response) => {
						handleNodeChange(
							id,
							response?.GetFilteredTasksV2?.tasksTreeResponse
								?.thisTaskViews
						);
						newlyFetched.push(
							response?.GetFilteredTasksV2?.tasksTreeResponse
								?.thisTaskViews
						);
					}
				);
			}

			// // 5) update your cache of fetched GUIDs
			if (newlyFetched.length) {
				setFetchedData((prev) => [...prev, ...idsToFetch]);
			}
		},
		[
			data,
			fetchedData,
			handleNodeChange,
			fetchNewTasks,
			collectIds,
			chipFilters,
			page,
			pageSize,
			fromTicket,
			fromProjectTasks,
			storeUserGuid,
			storeUserTenant,
			pID,
			tkID,
		] // dependencies
	);

	useEffect(() => {
		let v = expanded;
		if (v === true) {
			const r =
				data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews?.reduce(
					(acc, tv) => {
						if (tv?.task?.hasChildren !== true) return acc;
						acc[tv.task.guid] = true;
						return acc;
					},
					{}
				) ?? {};

			void getExpandedRowsData(r);
		} else {
			void getExpandedRowsData(expanded);
		}
	}, [expanded]);

	const findProjectDetails = (data, rowID) => {
		for (let item of data) {
			if (item?.task?.guid === rowID || item?.task?.taskGuid === rowID) {
				return {
					projectGuid: item.task.projectGuid,
					projectName: item.task.projectName,
					title: item.task.title,
					billable: item.task.billable,
					externalReference: item.task.externalReference,
				};
			}

			if (item.subtasks && item.subtasks.length > 0) {
				for (let subtask of item.subtasks) {
					if (
						subtask?.task?.guid === rowID ||
						subtask?.task?.taskGuid === rowID
					) {
						return {
							projectGuid: subtask.task.projectGuid,
							projectName: subtask.task.projectName,
							title: subtask.task.title,
							billable: item.task.billable,
							externalReference: item.task.externalReference,
						};
					}

					// Recursive search in deeper subtasks
					const result = findProjectDetails(
						subtask?.subtasks || [],
						rowID
					);
					if (result) {
						return result;
					}
				}
			}
		}

		return null;
	};

	const handleAddNew = (type) => {
		if (type === "subtask") {
			const res = table.getSelectedRowModel();
			const rowID = Object.keys(res)[0]?.split(".")[0];

			const projectDetails = findProjectDetails(
				data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews || [],
				rowID
			);

			if (projectDetails) {
				const {
					projectGuid,
					projectName,
					title,
					billable,
					externalReference,
				} = projectDetails;
				setModalData({
					taskGuid: rowID,
					title: title,
					billable: billable,
					externalReference: externalReference,
					projectGuid: projectGuid,
					projectName: projectName,
				});

				setTimeout(() => {
					setOpenModal(true);
				}, 500);
			} else {
				setModalData(null);
				setTimeout(() => {
					setOpenModal(true);
				}, 500);
			}
		} else {
			setModalData({
				taskGuid: null,
				projectGuid: null,
				projectName: null,
				title: null,
				billable: null,
				externalReference: null,
			});
			setTimeout(() => {
				setOpenModal(true);
			}, 500);
		}
	};
	const customButtons = [
		{
			label: "table.board",
			handleClick: () => setShowAsBoard(true),
			disabled: loading,
			condition: true,
			icon: true,
			iconButton: (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					width="24"
					height="24"
					stroke-width="2"
				>
					<path d="M4 4l6 0"></path>
					<path d="M14 4l6 0"></path>
					<path d="M4 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
					<path d="M14 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
				</svg>
			),
		},
		{
			label: "dashboard.subtask.addNew",
			handleClick: () => {
				setType("subtask");
				handleAddNew("subtask");
			},
			condition:
				(Object.keys(rowSelection).length === 0 ||
					Object.keys(rowSelection).length === 1) &&
				(!selected || selected.length === 0) &&
				isEmployee !== Mnemonic.ResourceTypes.External,
			icon: true,
			iconButton: <SubtaskIcon color={colors.light_logo_blue} />,
		},
		{
			label: "dashboard.task.addNew",
			handleClick: () => {
				setType("task");
				handleAddNew("task");
			},
			condition:
				Object.keys(rowSelection).length === 0 &&
				(!selected || selected.length === 0) &&
				isEmployee !== Mnemonic.ResourceTypes.External &&
				manageTimeEntry === "M" &&
				!fromSubtask,
			icon: true,
			iconButton: (
				<AddCircleRoundedIcon
					sx={{
						color: colors.light_logo_blue,
						fontSize: "28px !important",
					}}
				/>
			),
		},
	];

	function removeTaskByGuid(tasks, guidsArray) {
		return tasks?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews?.filter(
			(task) => {
				const hasMatchingGuid = guidsArray.includes(task.task.taskGuid);
				if (hasMatchingGuid) {
					return false;
				}
				if (task.subtasks)
					task.subtasks = removeTaskByGuid(task.subtasks, guidsArray);
				return true;
			}
		);
	}

	const handleDelete = () => {
		const res = table.getSelectedRowModel();

		deleteRecords(
			{
				variables: {
					model: {
						list: res?.flatRows.map((r) => r?.original?.task?.taskGuid),
					},
				},
			},
			(response) => {
				enqueueSnackbar(t("task.list.delete.success"), {
					variant: "success",
				});
				if (pID)
					setData(
						removeTaskByGuid(
							data,
							res?.flatRows.map((r) => r.original?.task?.taskGuid)
						)
					);
				else {
					const dataArr =
						data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews?.filter(
							(d) =>
								!res?.flatRows
									.map((r) => r.original?.task?.taskGuid)
									.includes(d.task.taskGuid)
						);
					setData(dataArr);
				}

				setSelected([]);
				// setDeleteIcon(false);
				setRowSelection({});
				// setRowGuid("");
				if (!pID) {
					setPage(0);
					// setRe((v) => !v);
				}
			}
		);
	};

	const handleOpenModal = (row) => {
		const res = table.getSelectedRowModel();
		const rowID = Object.keys(res)[0]?.split(".")[0];

		if (fromSubtask) {
			handleCloseModal();
		}
		setModalData({
			taskID: fromSubtask && !row ? null : row?.task?.taskGuid,
			projectID: fromSubtask && row?.task?.ticket?.project?.projectGuid,
			taskName: fromSubtask && !row ? null : row?.task?.title,
			projectName: fromSubtask
				? modalData?.projectName
				: row?.task?.ticket?.project?.title
				? row?.task?.ticket?.project?.title
				: data?.map((x) => x.task).filter((x) => x.guid === rowID)[0]
						?.projectName
				? data?.map((x) => x.task).filter((x) => x.guid === rowID)[0]
						?.projectName
				: null,
			parent: {
				taskGuid: parentGuid,
				title: parentName,
			},
		});

		setType(fromSubtask ? "subtask" : "task");
		addNewSubtask.current = fromSubtask;

		setTimeout(() => {
			setOpenModal(true);
		}, 500);
	};
	const tablePagination = {
		rows: [],
		columns: [],
		order,
		setOrder,
		orderBy,
		setOrderBy,
		selected,
		defaultFilters,
		setDefaultFilters,
		setSelected,
		search,
		setSearch: (v) => {
			handleSearch(v);
		},
		fetchTableData: showParents ? null : () => {},
		handleRefresh: () => {
			console.log("Refreshing data");
		},
		page: 1,
		rowsPerPage: 20,
		numberRecords: 0,
		getTreeData: handleRefetchTree,
		loading: loading,
		searchText: fromTenant
			? "task.list.search.label.fromTenant"
			: "task.list.search.label",
		refetch: handleRefetchTree,
		tableMnemonic: Mnemonic.Tables.TasksBacklog,
		filtersObject,
		generateRoute: (row) =>
			fromTenant
				? !fromTicket
					? tenant_project_direct_tasks_form
							.replace(
								"/:tName/:tID",
								`/${encodeURIComponent(tName)}/${encodeURIComponent(
									tID
								)}`
							)
							.replace(
								"/:pName/:pID",
								`/${encodeURIComponent(
									row?.ticket?.project?.title
								)}/${encodeURIComponent(
									row?.ticket?.project?.projectGuid
								)}`
							)
							.replace(
								"/:tskName/:tskID",
								`/${encodeURIComponent(
									row?.title
								)}/${encodeURIComponent(row?.taskGuid)}`
							)
					: tenant_project_tasks_form
							.replace(
								"/:tName/:tID",
								`/${encodeURIComponent(tName)}/${encodeURIComponent(
									tID
								)}`
							)
							.replace(
								"/:pName/:pID",
								`/${encodeURIComponent(
									row?.ticket?.project?.title
								)}/${encodeURIComponent(
									row?.ticket?.project?.projectGuid
								)}`
							)
							.replace(
								"/:tkName/:tkID",
								`/${encodeURIComponent(tkName)}/${encodeURIComponent(
									tkID
								)}`
							)
							.replace(
								"/:tskName/:tskID",
								`/${encodeURIComponent(
									row?.title
								)}/${encodeURIComponent(row?.taskGuid)}`
							)
				: !fromTicket
				? outSide
					? project_backlog_tasks.replace(
							"/:tskName/:tskID",
							`/${encodeURIComponent(row?.title)}/${encodeURIComponent(
								row?.taskGuid
							)}`
					  )
					: my_project_direct_tasks_form
							.replace(
								"/:pName/:pID",
								`/${encodeURIComponent(
									row?.ticket?.project?.title
								)}/${encodeURIComponent(
									row?.ticket?.project?.projectGuid
								)}`
							)
							.replace(
								"/:tskName/:tskID",
								`/${encodeURIComponent(
									row?.title
								)}/${encodeURIComponent(row?.taskGuid)}`
							)
				: my_project_tasks_form
						.replace(
							"/:pName/:pID",
							`/${encodeURIComponent(
								row?.ticket?.project?.title
							)}/${encodeURIComponent(
								row?.ticket?.project?.projectGuid
							)}`
						)
						.replace(
							"/:tkName/:tkID",
							`/${encodeURIComponent(tkName)}/${encodeURIComponent(
								tkID
							)}`
						)
						.replace(
							"/:tskName/:tskID",
							`/${encodeURIComponent(row?.title)}/${encodeURIComponent(
								row?.taskGuid
							)}`
						),
		disableAddBtn: true,
		deleteText: "task.list.delete.label",
		handleDelete: handleDelete,
		deleteLoading,
		readOnly: isEmployee === Mnemonic.ResourceTypes.External,
		handleOpenModal: handleOpenModal,
		handleChangeState: (v) => setFilterState(v),
		customButtons,
		setPagination: (pagination) => {
			setPage(pagination.pageIndex);
			setPageSize(pagination.pageSize);
		},
		disableSearchRefetch: true,
		heightClassName:
			pID !== null && pID !== undefined && pID !== ""
				? showQuickFilters === true
					? "table-project-filter-height"
					: "table-project-height"
				: showQuickFilters === true
				? "table-filter-height"
				: "table-height",
	};

	const handleChipClick = (newChipFilters) => {
		let updatedDefaultFilters = { ...defaultFilters };
		let updatedFilterState = [...filterState];

		if (newChipFilters.assignedToMe) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
				employeeIDs: [storeUserGuid],
			};

			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value = [storeUserGuid];
			} else {
				updatedFilterState.push({
					value: [storeUserGuid],
					property: "employeeIDs",
				});
			}

			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				updatedFilterState[teamIndex].value =
					updatedFilterState[teamIndex]?.value || [];
			} else {
				updatedFilterState.push({ value: null, property: "teamsIDs" });
			}
		} else {
			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value = updatedFilterState[
					employeeIndex
				].value?.filter((id) => id !== storeUserGuid);

				if (updatedFilterState[employeeIndex].value?.length === 0) {
					updatedFilterState.splice(employeeIndex, 1);
				}
			}

			//  delete updatedDefaultFilters.employeeIDs;
		}

		if (newChipFilters.assignedToMyTeam) {
			const filteredTeams = storeUserTeams?.map((x) => x.team);
			const filteredTeamsGuids = filteredTeams.map((t) => t.teamGuid);

			updatedDefaultFilters = {
				...updatedDefaultFilters,
				teamsIDs: filteredTeamsGuids,
			};

			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				updatedFilterState[teamIndex].value = filteredTeamsGuids;
			} else {
				updatedFilterState.push({
					value: filteredTeamsGuids,
					property: "teamsIDs",
				});
			}

			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value =
					updatedFilterState[employeeIndex].value?.map(
						(x) => x?.employeeGuid
					) || [];
			} else {
				updatedFilterState.push({ value: null, property: "employeeIDs" });
			}
		} else {
			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				const existingTeamIDs = updatedFilterState[teamIndex].value || [];
				const filteredTeams = storeUserTeams?.map((x) => x.team);
				const filteredTeamsGuids = filteredTeams.map((t) => t.teamGuid);
				updatedFilterState[teamIndex].value = existingTeamIDs.filter(
					(id) => !filteredTeamsGuids.includes(id)
				);

				if (updatedFilterState[teamIndex].value?.length === 0) {
					updatedFilterState.splice(teamIndex, 1);
				}
			}
		}

		if (newChipFilters.myProjectTasks) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
			};
		}

		if (newChipFilters.highPriority) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
				priority: null,
			};

			const priorityIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "priority"
			);
			if (priorityIndex >= 0) {
				updatedFilterState[priorityIndex].value = null;
			} else {
				updatedFilterState.push({ value: null, property: "priority" });
			}
		}

		setDefaultFilters(updatedDefaultFilters);
		setFilterState(updatedFilterState);
		//todo fix me
		// setChipFiltersClicked(true);

		// setChipFiltersClicked(!chipFiltersClicked);
	};

	const chips = [
		{
			label: t("ts.showParent"),
			tooltip: t("ts.tooltip.showParent"),
			onClick: () => {
				count.current = count.current + 1;
				// handleChips({
				//   ...chipFilters,
				//   showParents: !chipFilters.showParents,
				// })

				const newShowParents = !chipFilters.showParents;
				const newChipFilters = {
					...chipFilters,
					showParents: newShowParents,
				};
				setShowParents(!showParents);
				setChipFilters(newChipFilters);
				setPage(0);
				setPageSize(20);
				// setPagination({ pageIndex: 0, pageSize: 20 });
			},
			color: chipFilters.showParents ? "primary" : "default",
			variant: chipFilters.showParents ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.showParents
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
			visible: pID ? true : false,
		},

		{
			label: t("ts.AssignedToMe"),
			tooltip: t("ts.assignedtometooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newAssignedToMe = !chipFilters.assignedToMe;
				const newChipFilters = {
					...chipFilters,
					assignedToMe: newAssignedToMe,
					myProjectTasks:
						chipFilters.assignedToMyTeam || newAssignedToMe
							? false
							: true,
				};
				setChipFilters(newChipFilters);
				setAssignedToMe(newAssignedToMe);
				if (!newAssignedToMe && !chipFilters.assignedToMyTeam) {
					//todo: fix me
					// setMyProjectTasks(true);
				}
				handleChipClick(newChipFilters);
				setPage(0);
				setPageSize(20);
				// setPagination({ pageIndex: 0, pageSize: 20 });
			},
			color: chipFilters.assignedToMe ? "primary" : "default",
			variant: chipFilters.assignedToMe ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.assignedToMe
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},

		{
			label: t("ts.AssignedToMyTeam"),
			tooltip: t("ts.assignedtomeyteamtooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newAssignedToMyTeam = !chipFilters.assignedToMyTeam;
				const newChipFilters = {
					...chipFilters,
					assignedToMyTeam: newAssignedToMyTeam,
					myProjectTasks:
						chipFilters.assignedToMe || newAssignedToMyTeam
							? false
							: true,
				};
				setChipFilters(newChipFilters);
				// setAssignedToMyTeam(newAssignedToMyTeam);
				if (!newAssignedToMyTeam && !chipFilters.assignedToMe) {
					//todo: fix me
					// setMyProjectTasks(true);
				}
				handleChipClick(newChipFilters);
				setPage(0);
				setPageSize(20);
				// setPagination({ pageIndex: 0, pageSize: 20 });
			},
			color: chipFilters.assignedToMyTeam ? "primary" : "default",
			variant: chipFilters.assignedToMyTeam ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.assignedToMyTeam
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},

		{
			label: t("ts.OnlyTasks"),
			tooltip: t("ts.taskstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				setChipFilters((prevFilters) => {
					const newOnlyTasks = !prevFilters.onlyTasks;
					const newOnlySubtasks = prevFilters.onlySubtasks;

					if (!newOnlyTasks && !newOnlySubtasks) {
						return {
							...prevFilters,
							onlyTasks: false,
							onlySubtasks: true,
						};
					}

					//todo: fix me
					// setOnlyTasks(newOnlyTasks);
					return {
						...prevFilters,
						onlyTasks: newOnlyTasks,
					};
				});
				setPage(0);
				setPageSize(20);
				// setPagination({ pageIndex: 0, pageSize: 20 });
			},
			color: chipFilters.onlyTasks ? "primary" : "default",
			variant: chipFilters.onlyTasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.onlyTasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.OnlySubtasks"),
			tooltip: t("ts.subtaskstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				setChipFilters((prevFilters) => {
					const newOnlySubtasks = !prevFilters.onlySubtasks;
					const newOnlyTasks = prevFilters.onlyTasks;

					if (!newOnlySubtasks && !newOnlyTasks) {
						return {
							...prevFilters,
							onlySubtasks: false,
							onlyTasks: true, // Turn on onlyTasks if both would be off
						};
					}

					// setOnlySubtasks(newOnlySubtasks);
					return {
						...prevFilters,
						onlySubtasks: newOnlySubtasks,
					};
				});
				// setPagination({ pageIndex: 0, pageSize: 20 });
				setPage(0);
				setPageSize(20);
			},
			color: chipFilters.onlySubtasks ? "primary" : "default",
			variant: chipFilters.onlySubtasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.onlySubtasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},

		{
			label: t("ts.myprojectTasks"),
			tooltip: t("ts.myprojectstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newMyProjectTasks = !chipFilters.myProjectTasks;
				const newChipFilters = {
					...chipFilters,
					myProjectTasks: newMyProjectTasks,
					assignedToMe: newMyProjectTasks
						? false
						: chipFilters.assignedToMe,
					assignedToMyTeam: newMyProjectTasks
						? false
						: chipFilters.assignedToMyTeam,
				};
				setChipFilters(newChipFilters);
				// setMyProjectTasks(newMyProjectTasks);
				if (
					!newMyProjectTasks &&
					!chipFilters.assignedToMe &&
					!chipFilters.assignedToMyTeam &&
					!isAdmin
				) {
					setAssignedToMe(true);
					newChipFilters.assignedToMe = true;
				}
				handleChipClick(newChipFilters);
				setPage(0);
				setPageSize(20);
				// setPagination({ pageIndex: 0, pageSize: 20 });
			},
			color: chipFilters.myProjectTasks ? "primary" : "default",
			variant: chipFilters.myProjectTasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.myProjectTasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},

		{
			tooltip: t("ts.prioritytooltip"),
			icon: getOptionPriorityIcon("High", { marginRight: "-17px" }),
			visible: true,

			onClick: () => {
				count.current = count.current + 1;
				const newChipFilters = {
					...chipFilters,
					highPriority: true,
				};
				// handleChips({
				//   ...chipFilters,
				//   doing: !chipFilters.doing,
				// })

				handleChipClick(newChipFilters);
				setDoing(!doing);
				setChipFilters((prevFilters) => ({
					...prevFilters,
					doing: !prevFilters.doing,
				}));
				// setPagination({ pageIndex: 0, pageSize: 20 });
				// refetchData();
				setPage(0);
				setPageSize(20);
			},
			color: doing ? "primary" : "default",
			variant: doing ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: doing ? "white" : `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: openSavedFilters
				? t("ts.hideSavedFilters")
				: t("ts.showSavedFilters"),
			onClick: () => {
				setOpenSavedFilters((oldValue) => !oldValue);
			},
			variant: openSavedFilters ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: openSavedFilters
						? `${colors.icon_button_grey} !important`
						: `${colors.chip_label} !important`,
				},
			},
			visible: true,
		},
	];

	const handleApplyFilter = (guid, filterObject) => {
		setPage(0);
		if (!pID) {
			localStorage.setItem("task_filter", JSON.stringify(filterObject));
			localStorage.setItem("task_filter_guid", guid);
			console.log("Task filter applied:", filterObject);
		} else {
			localStorage.setItem(
				"project_task_filter",
				JSON.stringify(filterObject)
			);
			localStorage.setItem("project_task_filter_guid", guid);
			localStorage.setItem("project_filter_guid", pID);
		}
		const parsedObject = JSON.parse(filterObject);
		const quickFilters = parsedObject?.quickFilters;

		setDefaultFilters(parsedObject?.filters);
		setSelectedFilterGuid(guid);
		setChipFilters({
			showParents: quickFilters?.showParents,
			assignedToMe: quickFilters?.myTasks,
			assignedToMyTeam: quickFilters?.myTeamsTasks,
			onlySubtasks: quickFilters?.onlySubtasks,
			onlyTasks: quickFilters?.onlyTasks,
			myProjectTasks: quickFilters?.myProjectTasks,
			doing: quickFilters?.doing,
		});
		setDoing(quickFilters?.highPriority);
	};

	const handleRemoveUserTableFilters = () => {
		removeUserTableFiltersData(
			{
				variables: {
					model: {
						filterID: filterGuidToBeRemoved,
						userID: storeUserGuid,
						projectID: pID,
					},
				},
			},
			(response) => {
				if (
					response["RemoveUserTableFilters"].errorCode !== null &&
					response["RemoveUserTableFilters"].errorCode !== ""
				) {
					enqueueSnackbar(
						t(response["RemoveUserTableFilters"].errorMessage),
						{
							variant: "error",
							autoHideDuration: 5000,
						}
					);
				} else {
					enqueueSnackbar(t("task.list.deletedSuccessfully"), {
						variant: "success",
					});
					setSelectedFilterGuid(null);
					if (!pID) {
						localStorage.removeItem("task_filter");
						localStorage.removeItem("task_filter_guid");
					} else {
						localStorage.removeItem("project_task_filter");
						localStorage.removeItem("project_task_filter_guid");
						localStorage.removeItem("project_filter_guid");
					}
					if (selectedFilterGuid === filterGuidToBeRemoved) {
						setFilterGuidToBeRemoved(null);
						setDefaultFilters(null);
						setFilterState([]);
						setChipFilters({
							showParents: pID ? true : false,
							assignedToMe: true,
							assignedToMyTeam: true,
							onlySubtasks: true,
							onlyTasks: true,
							myProjectTasks: false,
							doing: false,
						});
						// setDe((v) => !v);
					}
					refetchFilters();
				}
			},
			(error) => {}
		);
	};
	const handleCloseDeleteFilterModal = () => {
		setOpenDeleteFilterModal(false);
	};
	const customDeleteFilterModalButtons = () => (
		<>
			<CustomButton
				onClick={() => {
					handleRemoveUserTableFilters();
					handleCloseDeleteFilterModal();
				}}
				label={t("dialog.yes")}
			/>
			<div>
				<CustomButton
					onClick={handleCloseDeleteFilterModal}
					label={t("dialog.cancel")}
				/>
			</div>
		</>
	);
	return (
		<>
			<ConfirmationModal
				contentText={`${t("tasksBacklog.movedRow")}  "${
					targetRow?.title
				}" ?`}
				title={t("dialog.warning")}
				icon={"warning"}
				openDialog={openMovedRowDialog}
				handleClose={handleMovedRowClose}
				customButtons={customModalMovedRowButtons}
				t={t}
			/>
			<TaskTabsModal
				showModal={openModal}
				setShowModal={(v) => setOpenModal(v)}
				loading={loading}
				projectID={modalData?.projectID}
				projectName={modalData?.projectName}
				taskID={modalData?.taskID}
				handleChangeTask={(v) => setModalData({ ...modalData, taskID: v })}
				handleChangeProject={(v) =>
					setModalData({ ...modalData, projectID: v })
				}
				taskName={modalData?.taskName}
				refetch={refetchTasks}
				fromProject={true}
				open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
				modifyFormFlag={() =>
					sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
				}
				type={type}
				setType={(v) => setType(v)}
				parent={modalData?.parent}
				taskStatusList={statusData?.GetTaskStatuses?.tasksStatus || []}
				data={
					data?.GetFilteredTasksV2?.tasksTreeResponse?.thisTaskViews || []
				}
				updateData={(v) => {
					setData((prev) => {
						return {
							...prev,
							GetFilteredTasksV2: {
								...prev.GetFilteredTasksV2,
								tasksTreeResponse: {
									...prev.GetFilteredTasksV2.tasksTreeResponse,
									thisTaskViews: v,
								},
							},
						};
					});
				}}
				totalFilters={chipFilters}
				// addNewSubtask={addNewSubtask.current}
				editMode={!addNewSubtask.current}
			/>
			<ConfirmationModal
				contentText={t("task.list.deleteFilter.dialog.text")}
				title={t("dialog.warning")}
				icon={"warning"}
				openDialog={openDeleteFilterModal}
				handleClose={() => {
					handleCloseDeleteFilterModal();
				}}
				customButtons={customDeleteFilterModalButtons}
				t={t}
			/>
			<Grid container>
				<Grid
					item
					xs={openSavedFilters ? 10.5 : 12}
					sx={openSavedFilters ? { paddingRight: "10px !important" } : {}}
				>
					{showAsBoard ? (
						<TaskBoard
							doing={doing}
							setDoing={setDoing}
							openSavedFilters={openSavedFilters}
							setOpenSavedFilters={setOpenSavedFilters}
							fromTicket={fromTicket}
							fromProjectTasks={fromProjectTasks}
							chipFilters={chipFilters}
							setChipFilters={setChipFilters}
							fromTenant={fromTenant}
							refetchStatus={() => {}}
							parentName={parentName}
							refetch={() => {}}
							parentGuid={parentGuid}
							handleCloseModal={handleCloseModal}
							fromSubtask={fromSubtask}
							fromEmployeeAvailability={fromEmployeeAvailability}
							defaultFilters={defaultFilters}
							setDefaultFilters={setDefaultFilters}
							handleSaveUserTableFilters={handleSaveUserTableFilters}
							refetchFilters={refetchFilters}
							selectedFilterGuid={selectedFilterGuid}
							savedFilters={
								getFilters?.GetUserTableFilters?.userTableFiltersList ||
								[]
							}
							fromProject={fromProject}
							getColumnsLoading={getColumnsLoading}
							fromBacklog={fromBacklog}
							statusLoading={false}
							employeesList={
								employeesData?.GetCompanyUsersList?.usersList
									?.employees || []
							}
							taskStateList={
								statusData?.GetTaskStatuses?.tasksStatus || []
							}
							teams_list={
								teamsData?.GetTeamsList?.teamsList?.teams || []
							}
							projectsList={
								projectsData?.GetAllProjects?.projectsList
									?.projectViews || []
							}
							areaList={areaData?.GetAreasList?.areasList?.areas || []}
							taskList={parentTaskData?.GetTasks?.tasks || []}
							teamsLoading={false}
							projectLoading={false}
							employeeLoading={false}
							areaLoading={false}
							taskLoading={loading}
							employeeWait={false}
							showAsBoard={showAsBoard}
							setShowAsBoard={setShowAsBoard}
						/>
					) : (
						<>
							<DataTable
								{...tablePagination}
								treeTable={true}
								deleteIcon={Object.keys(rowSelection).length > 0}
								identifier={"task.taskGuid"}
								hasCheckbox
								quickFilters
								chips={chips}
								rightChips={[]}
								chipFilters={chipFilters}
								handleDefaultFilters={(f) => setFilters(f)}
								handleShowQuickFilters={(t) => setShowQuickFilters(t)}
								savedFilterFlag={true}
								showUpdateFilterButton={
									selectedFilterGuid !== null &&
									selectedFilterGuid !== undefined &&
									selectedFilterGuid !== ""
								}
								handleUpdateFilter={handleSaveUserTableFilters}
								handleSaveFilter={handleSaveUserTableFilters}
								handleClearFilter={() => setSelectedFilterGuid(null)}
								defaultChipFilters={{
									showParents: pID ? true : false,
									assignedToMe: pID ? false : true,
									assignedToMyTeam: pID ? false : true,
									onlySubtasks: true,
									onlyTasks: true,
									myProjectTasks: pID ? true : false,
									doing: false,
								}}
								handleResetChipFilter={() =>
									setChipFilters({
										showParents: pID ? true : false,
										assignedToMe: false,
										assignedToMyTeam: false,
										onlySubtasks: true,
										onlyTasks: true,
										myProjectTasks: isAdmin
											? false
											: !isAdmin && pID
											? true
											: false,
										doing: false,
									})
								}
								ticketHeight={fromTicket ? true : false}
							/>
							<MaterialReactTable
								table={table}
								// key={Math.random()}
							/>
						</>
					)}
				</Grid>

				{openSavedFilters && (
					<Grid item xs={1.5} className="savedFilters">
						<SavedFilters
							filters={
								getFilters?.GetUserTableFilters?.userTableFiltersList ||
								[]
							}
							loading={filterLoading}
							handleApplyFilter={handleApplyFilter}
							selectedFilterGuid={selectedFilterGuid}
							handleSaveUserTableFilters={handleSaveUserTableFilters}
							handleRemoveUserTableFilters={(guid) => {
								setFilterGuidToBeRemoved(guid);
								setOpenDeleteFilterModal(true);
							}}
						/>
					</Grid>
				)}
			</Grid>
		</>
	);
}

export default TaskList;
